import { useQuery } from '@tanstack/react-query'

import type { LegalDocument } from '../types'

import { api } from '@/shared/services/api'

export function useLegalDocuments() {
  return useQuery({
    queryKey: ['/public/legal_documents/current'],
    queryFn: async () => {
      const { data } = await api.get<{ records: LegalDocument[] }>(
        '/public/legal_documents/current'
      )
      return data.records
    }
  })
}
